import { useMutation } from '@tanstack/react-query';

import { updateProfile } from '@services/profile/profile.service';

import type { ProfileUpdate } from '@services/profile/profile.types';

export interface UpdateProfileVariables {
  cpf: string;
  payload: ProfileUpdate;
}

export function useUpdateProfile(accessToken: string) {
  return useMutation({
    mutationFn: ({ cpf, payload }: UpdateProfileVariables) => updateProfile(cpf, payload, accessToken),
  });
}
